/*
  LZX Pesca — menu de categorias do estoque e a faixa que corre para o lado.

  O trabalho de verdade aqui não é trocar de aba: é não pagar por abas que
  ninguém abriu. Cada categoria não visível chega dentro de um <template>,
  onde nada carrega — nem imagem, nem vídeo — e só vira DOM no primeiro
  clique. Sem isso, cinco categorias de vídeo em autoplay travariam o
  celular do cliente antes mesmo dele rolar a página.

  Ao sair de uma aba os vídeos dela param. Vídeo pausado fora da tela ainda
  ocupa memória, mas não decodifica quadro.

  A faixa em si é do CSS: `overflow-x` mais `scroll-snap` já entregam o
  arrasto com o dedo, que é o gesto do celular. O JS só acrescenta as setas
  do computador — e precisa saber ligar faixas que nasceram de um
  <template>, depois do carregamento da página.
*/

(function () {
  'use strict';

  /*
    Rola uma tela inteira por clique, não um quadro: o visitante vê um
    conjunto novo a cada vez, em vez de um quadro pela metade.
  */
  function ligarFaixa(faixa) {
    if (faixa.dataset.lzxReady) return;
    faixa.dataset.lzxReady = '1';

    var trilho = faixa.querySelector('[data-lzx-stock-track]');
    var anterior = faixa.querySelector('[data-lzx-stock-prev]');
    var proximo = faixa.querySelector('[data-lzx-stock-next]');
    if (!trilho || !anterior || !proximo) return;

    function revisar() {
      /* 2px de folga: com larguras fracionárias o scrollLeft nunca alcança
         exatamente o máximo, e a seta jamais se apagaria. */
      var limite = trilho.scrollWidth - trilho.clientWidth;
      anterior.disabled = trilho.scrollLeft <= 2;
      proximo.disabled = trilho.scrollLeft >= limite - 2;
    }

    anterior.addEventListener('click', function () {
      trilho.scrollBy({ left: -trilho.clientWidth, behavior: 'smooth' });
    });
    proximo.addEventListener('click', function () {
      trilho.scrollBy({ left: trilho.clientWidth, behavior: 'smooth' });
    });
    trilho.addEventListener('scroll', revisar, { passive: true });
    window.addEventListener('resize', revisar);
    revisar();
  }

  function iniciar(raiz) {
    raiz.querySelectorAll('[data-lzx-stock-rail]').forEach(ligarFaixa);

    raiz.querySelectorAll('[data-lzx-stock]').forEach(function (sec) {
      if (sec.dataset.lzxReady) return;
      sec.dataset.lzxReady = '1';

      var abas = Array.prototype.slice.call(sec.querySelectorAll('[data-lzx-stock-tab]'));
      var palco = sec.querySelector('[data-lzx-stock-panels]');
      if (!abas.length || !palco) return;

      /* Clona a categoria do <template> na primeira vez que ela é aberta. */
      function garantirPainel(slug) {
        var pronto = palco.querySelector('[data-lzx-stock-panel="' + slug + '"]');
        if (pronto) return pronto;

        var molde = palco.querySelector('[data-lzx-stock-tpl="' + slug + '"]');
        if (!molde) return null;

        var painel = document.createElement('div');
        painel.className = 'lzx-stock__panel';
        painel.setAttribute('role', 'tabpanel');
        painel.dataset.lzxStockPanel = slug;
        painel.appendChild(molde.content.cloneNode(true));
        palco.appendChild(painel);

        /* Ligar a faixa só depois de anexada, e enquanto o painel ainda está
           visível: as setas se apagam a partir de medidas do trilho, e
           elemento escondido mede zero. */
        painel.querySelectorAll('[data-lzx-stock-rail]').forEach(ligarFaixa);
        return painel;
      }

      function ativar(slug) {
        if (!garantirPainel(slug)) return;

        abas.forEach(function (aba) {
          var ligada = aba.dataset.lzxStockTab === slug;
          aba.classList.toggle('is-active', ligada);
          aba.setAttribute('aria-selected', ligada ? 'true' : 'false');
        });

        palco.querySelectorAll('[data-lzx-stock-panel]').forEach(function (painel) {
          var ligado = painel.dataset.lzxStockPanel === slug;
          painel.hidden = !ligado;

          painel.querySelectorAll('video').forEach(function (video) {
            if (!ligado) {
              video.pause();
              return;
            }
            /* O autoplay pode ser recusado (economia de bateria, por
               exemplo). É recusa esperada, não erro a reportar. */
            var tocando = video.play();
            if (tocando && tocando.catch) tocando.catch(function () {});
          });
        });
      }

      abas.forEach(function (aba, i) {
        aba.addEventListener('click', function () {
          ativar(aba.dataset.lzxStockTab);
        });

        aba.addEventListener('keydown', function (e) {
          var passo = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!passo) return;
          e.preventDefault();
          var alvo = abas[(i + passo + abas.length) % abas.length];
          alvo.focus();
          ativar(alvo.dataset.lzxStockTab);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
  } else {
    iniciar(document);
  }
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
